/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TextSnippetVisibilityEnum } from './textSnippetVisibilityEnum';
import { TextSnippetPermissions } from './textSnippetPermissions';
import { TextSnippetOwner } from './textSnippetOwner';


/**
 * One snippet with its content; also creates and changes it.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface TextSnippet { 
    readonly id: number;
    title: string;
    tags?: Array<string>;
    visibility?: TextSnippetVisibilityEnum;
    readonly owner: TextSnippetOwner | null;
    practice?: number | null;
    readonly practiceName: string | null;
    readonly preview: string;
    readonly permissions: TextSnippetPermissions;
    readonly updatedAt: string | null;
    content?: string;
}
export namespace TextSnippet {
}

export const TextSnippet_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_title_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const TextSnippet_tags_Validators: ValidatorFn[] =
    [ ];

export const TextSnippet_visibility_Validators: ValidatorFn[] =
    [ ];

export const TextSnippet_owner_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_practice_Validators: ValidatorFn[] =
    [ ];

export const TextSnippet_practiceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_preview_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_permissions_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_updatedAt_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TextSnippet_content_Validators: ValidatorFn[] =
    [ ];


